module.exports = __webpack_public_path__ + "static/img/1.7900ad9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/1.png
// module id = BB5z
// module chunks = 0